import { Roll } from '../production/roll';

export interface ProductionCardRollGroup {
  productionCardNumber: string;
  productionCardId: string;
  workOrderReference: string;
  colorReference: string;
  colorName?: string;
  rolls: Roll[];
}

export interface AvailableRollsResponse {
  productionCardGroups: Record<string, ProductionCardRollGroup>;
}

/**
 * Response of the paginated B-Grade endpoint. Pagination happens at the roll level (not the group
 * level), so `totalCount` is the total number of available rolls and a Production Card group may be
 * split across pages. When the search term matches a Production Card, the API returns every roll of
 * that card ignoring `pageSize`.
 */
export interface BGradeRollsPageResponse {
  productionCardGroups: ProductionCardRollGroup[];
  totalCount: number;
  pageSize: number;
  pageNumber: number;
}

/**
 * Page size the table starts with, matching the standard's default (R13); the user can switch to
 * 50 or 100 from the paginator. The endpoint defaults to 100 when no pageSize is sent and caps it
 * at 250.
 */
export const BGRADE_ROLLS_PAGE_SIZE = 25;

export interface AvailableRollsQuery {
  workOrderReferences: string[];
}
